class RAMQCaracteristiqueSante {
    public CodeSante: number;
    public Date: string;
}

export { RAMQCaracteristiqueSante };
